import { useCallback } from 'react';
import mixpanel from '../constants/MixpanelManager';

export const useMixpanelTracking = () => {
  const track = useCallback((eventName, properties = {}) => {
    mixpanel.track(eventName, properties);
  }, []);

  const identify = useCallback((userId, email = null, userName = null, userProfileImage = null) => {
    mixpanel.identify(userId, email, userName, userProfileImage);
  }, []);

  const reset = useCallback(() => {
    mixpanel.reset();
  }, []);

  return { track, identify, reset };
};
